import React from "react";
import toast from "react-hot-toast";
import { FaCross } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { createApiFromUrl } from "./api";

export const useCreateUrlHook = () => {

  const [otherDetails, setOtherDetails] = React.useState({
    title: "",
    description: "",
    tinySource: "",
    tinyMedium: "",
    tinyCampaign: "",
    tinyTerm: "",
    tinyContent: "",
    clientName: "",
    clientId: "",
    urlData: ""
  });

  const navigate = useNavigate();

  const setData = React.useCallback((key, value) => {
    setOtherDetails(details => {
      return {
        ...details,
        [key]: value
      }
    })
  }, [])

  const setUrlData = React.useCallback((newUrlData = "") => {
    setData('urlData', newUrlData)
  }, [setData])

  const navTo = React.useCallback((givenUrl) => { window.location.href = givenUrl }, [])

  const doSubmitUrl = React.useCallback((details) => {
    (async () => {
      const [data, err] = await createApiFromUrl(details);
      if (err)
        toast(err.response.data.message, {
          duration: 2000,
          icon: <FaCross />,
          style: {
            backgroundColor: "#ffabcd",
            fontSize: 14,
          },
        });
      if (data.account === 'inactive') {

        toast(data.message, {
          duration: 2000,
          icon: <FaCross />,
          style: {
            backgroundColor: "#ffabcd",
            fontSize: 14,
          },
        });
        localStorage.removeItem('token')
        setTimeout(() => navTo('/login'), 3000)
      } else {
        toast("👏 New link created! ", {
          duration: 3000,
          style: {
            backgroundColor: "#dde5b6",
            fontSize: 14,
          },
        });
        setTimeout(() => navigate('/list/view/' + data.shortCode), 3000)
      }
    })();
  }, [navigate, navTo]);


  const handleInputChange = (e) => {
    const nameOfInput = e.target.name;
    const value = e.target.value;
    setData(nameOfInput, value);
  }

  return {
    doSubmitUrl,
    otherDetails,
    setOtherDetails,
    setUrlData,
    setData,
    handleInputChange
  };
};
